import { type Environment, getEnvironment } from './getEnvironment';

const isFeatureEnabled = (allowedEnvironments: Environment[]): boolean => {
  const environment = getEnvironment();
  return allowedEnvironments.includes(environment);
};


export const isWebshopEnabled = isFeatureEnabled(['local', 'development', 'release']);
export const isBiomechanicsEnabled = isFeatureEnabled(['local','development', 'release']);
